import React from 'react'
import { CheckBox } from '@usap/uicomponents'
import {
  StyledCheckBoxLabel,
  StyledContainer,
  StyledSubtitle,
  StyledTextInput,
  StyledTextInputContainer,
  StyledTextInputError,
} from './NotifyFormWmo.css'
import ButtonWmo from '../../../../../Wmo/ButtonWmo/ButtonWmo'

const successMessage = 'You will receive an email when the item becomes available.'
const failedMessage = (
  <>
    <a href="/help-center/contact-us" target="_blank"><u>Contact us</u></a>
    {' '}
    for assistance.
  </>
)

const NotifyFormWmo = ({
  handleClose,
  handleSendEmail,
  handleChangeEmail,
  handleCheckBox,
  isFormSubmitted,
  isSent,
  isProcessing,
  buttonLabel,
  captcha,
  emailErrorMessage,
  email,
  checked,
}) => (
  <StyledContainer>
    {isFormSubmitted ? (
      <>
        <StyledSubtitle>{isSent ? successMessage : failedMessage}</StyledSubtitle>
        <ButtonWmo
          variant="highlight"
          label={isSent ? 'Continue shopping' : 'Close'}
          onClick={handleClose}
        />
      </>
    )
      : (
        <>
          <StyledSubtitle>Enter your email address below to be notified when items are back in stock</StyledSubtitle>
          <StyledTextInputContainer>
            <StyledTextInput
              id="emailAddress"
              name="emailAddress"
              type="email"
              focusIndicator={false}
              onChange={handleChangeEmail}
              placeholder="Enter Your Email Address"
              aria-label="email"
              value={email}
              error={emailErrorMessage}
            />
            {emailErrorMessage && <StyledTextInputError>{emailErrorMessage}</StyledTextInputError>}
          </StyledTextInputContainer>
          <CheckBox
            checked={checked}
            label={(
              <StyledCheckBoxLabel>
                Send me CarParts.com exclusive offers and promotions
              </StyledCheckBoxLabel>
                )}
            onChange={handleCheckBox}
          />
          {captcha}
          <ButtonWmo
            variant="highlight"
            label={buttonLabel}
            onClick={handleSendEmail}
            disabled={isProcessing}
          />
        </>
      )}
  </StyledContainer>
)

export default NotifyFormWmo
